import { ProfileLogin } from "@/auth/interfaces";

export interface EmpleadosPagingRes {
  count: number;
  next: string;
  previous: null;
  numero_paginas: number;
  data: Empleado[];
}

export interface Empleado {
  id_empleado?: string;

  codigo: string;
  tipo_identificacion: string;
  identificacion: string;
  razon_social: string;
  direccion: string;
  email: string;
  telefono_1: string;
  telefono_2: string;
  telefono_3: string;
  canal_venta?: string;
  canal_venta_adicional?: string;
  numero_referencia?: string;
  estado: boolean;

  ///* fk
  profile_data?: ProfileLogin,
  tipo_empleado?: string;
  pais?: string;
  provincia?: string;
  ciudad?: string;
  parroquia?: string;
  zona?: string;
  sector?: string;
  empresa?: string;
  area?: string;
  departamento?: string;
  user?: string | null;
  cargo?: string;
  username?: string | null;
}

export interface EmpleadoColor {
  username: string,
  color: string
}

export interface IEmpladoParams extends Partial<Empleado> {

}

export const ALL_EMPLADO = {
  codigo: 'VER_TODOS',
  razon_social: 'VER TODOS',
  user: null
}